import { fabric } from 'fabric'
import { TemplateTextbox } from './TemplateTextbox'

export const PromptTextbox = fabric.util.createClass(TemplateTextbox, {
    type: 'prompt-textbox',

    initialize: function (text, options) {
        options || (options = {})
        this.callSuper('initialize', text, options)

        // Should probably throw an error if these are missing.
        this.set('name', options.name || undefined)
        this.set('prompt', options.prompt || undefined)
    },

    toString: function () {
        return this.callSuper('toString') + ' (name: ' + this.get('name') + ')'
    },

    toObject: function () {
        return fabric.util.object.extend(this.callSuper('toObject'), {
            name: this.get('name'),
            prompt: this.get('prompt'),
        })
    },
})

fabric.PromptTextbox = PromptTextbox
fabric.PromptTextbox.fromObject = function (object, callback) {
    return fabric.Object._fromObject('PromptTextbox', object, callback, 'text')
}
